import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=6b7c7c7f&"
import script from "./ServicesList.vue?vue&type=script&lang=js&"
export * from "./ServicesList.vue?vue&type=script&lang=js&"
import style0 from "./ServicesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports